import PropTypes from 'prop-types';

const ArchiveSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 40}`}
      height={`${height || 40}`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M28.0312 3.18335H11.9646C8.43125 3.18335 5.53125 6.08335 5.53125 9.61668V33.1C5.53125 36.1 7.68125 37.3667 10.3146 35.9167L18.4479 31.4C19.3146 30.9167 20.7146 30.9167 21.5646 31.4L29.6979 35.9167C32.3312 37.3833 34.4813 36.1167 34.4813 33.1V9.61668C34.4646 6.08335 31.5812 3.18335 28.0312 3.18335Z"
        fill={color}
      />
      <path
        d="M18.4802 22.0833C18.1635 22.0833 17.8469 21.9667 17.5969 21.7167L15.0969 19.2167C14.6135 18.7333 14.6135 17.9333 15.0969 17.45C15.5802 16.9667 16.3802 16.9667 16.8635 17.45L18.4802 19.0667L24.2635 13.2833C24.7469 12.8 25.5469 12.8 26.0302 13.2833C26.5135 13.7667 26.5135 14.5667 26.0302 15.05L19.3635 21.7167C19.1135 21.9667 18.7969 22.0833 18.4802 22.0833Z"
        fill={color}
      />
    </svg>
  );
};

ArchiveSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ArchiveSvg;
